import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InitializerService } from '../../../../initializer.service';
import { urlApi } from '../../../../utils/apiConfig';


@Injectable()
export class RelatorioService {
  constructor(private http: HttpClient) {
   }

  public getReport(idReport: number): Observable<any>{
    return this.http.get(`${urlApi}/app/disparos/info/${idReport}`, {headers: {'Content-Type':'application/json', 'Authorization': localStorage.getItem('token') || ''}});
  }
}
